/* SHOP — add-to-cart (AJAX), cart count, toast, and the lightbox for the collection page.
   Every painting is ONE of a kind (inventory 1), so "add" is a yes/no: once it's in your cart the
   button turns into "In your cart", and Shopify refuses a second add (422) — we say so plainly. */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var inCart = {};
  (window.S16_CART || []).forEach(function (id) { inCart[id] = true; });

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  // ---- toast ----
  var toast = el("div", "toast"), toastT;
  toast.setAttribute("role", "status");
  document.body.appendChild(toast);
  function say(msg, err, link) {
    toast.innerHTML = "";
    toast.appendChild(el("span", null, msg));
    if (link) { var a = el("a", null, "View cart"); a.href = "/cart"; toast.appendChild(a); }
    toast.classList.toggle("err", !!err);
    toast.classList.add("show");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove("show"); }, 4500);
  }

  function setCount(n) {
    document.querySelectorAll(".nav__cart .count").forEach(function (c) { c.textContent = n; c.setAttribute("data-n", n); });
  }

  function markInCart(id) {
    inCart[id] = true;
    document.querySelectorAll('[data-add="' + id + '"]').forEach(function (b) { toInCart(b); });
  }
  function toInCart(b) {
    var a = el("a", "buy buy--ghost buy--sm", "In your cart ✓");
    a.href = "/cart";
    if (b.classList.contains("buy--lg")) {
      a.className = "buy buy--ghost buy--lg";
      // painting page: "Buy it now" would re-add the only one there is (Shopify 422) → go to checkout instead
      var form = b.parentNode && b.parentNode.querySelector("form");
      if (form) { var co = el("a", "buy buy--pink buy--lg", "Check out"); co.href = "/checkout"; form.replaceWith(co); }
    }
    b.replaceWith(a);
  }

  function add(id, btn) {
    if (inCart[id]) { say("That one’s already in your cart.", false, true); return; }
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) {
        // 422 = sold out, or already in the cart at the only one there is
        if (btn) btn.disabled = false;
        say(res.j && res.j.description ? String(res.j.description).replace(/<[^>]+>/g, "") : "Sorry — that painting just sold.", true);
        return;
      }
      markInCart(id);
      say("Added to your cart.", false, true);
      return fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); });
    }).catch(function () {
      if (btn) btn.disabled = false;
      say("Couldn’t reach the shop — check your connection and try again.", true);
    });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add]");
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    add(b.getAttribute("data-add"), b);
  });
  Object.keys(inCart).forEach(function (id) {
    document.querySelectorAll('[data-add="' + id + '"]').forEach(toInCart);
  });

  // ---- artist jump menu ----
  var jump = $("jump");
  if (jump) jump.addEventListener("change", function () {
    if (jump.value) { $(jump.value).scrollIntoView({ behavior: "smooth" }); jump.value = ""; }
  });

  // ---- lightbox: every painting in page order; ← → keys, arrows, swipe; price + add row ----
  var data = $("pieces");
  if (!data || !$("lb")) return;
  var ALL = JSON.parse(data.textContent), cur = -1, preload = [];
  function openLb(i) {
    var n = ALL.length; i = (i + n) % n; cur = i;
    var p = ALL[i], img = $("lb-img");
    img.classList.add("swap");
    img.onload = function () { img.classList.remove("swap"); };
    img.src = p.l; img.alt = p.a + " — " + p.t;
    var cap = $("lb-cap"); cap.innerHTML = "";
    cap.appendChild(el("b", null, p.a));
    cap.appendChild(document.createTextNode(" · " + p.t));
    if (p.d) { cap.appendChild(document.createElement("br")); cap.appendChild(el("span", "lbd", p.d)); }
    var act = $("lb-act"); act.innerHTML = "";
    if (p.s) {
      var st = el("span", "sold-tag"); st.appendChild(el("span", "dot")); st.appendChild(document.createTextNode("Sold"));
      act.appendChild(st);
    } else {
      act.appendChild(el("span", "price", p.p));
      if (inCart[p.v]) { var ic = el("a", "buy buy--ghost buy--sm", "In your cart ✓"); ic.href = "/cart"; act.appendChild(ic); }
      else { var b = el("button", "buy buy--pink buy--sm", "Add to cart"); b.type = "button"; b.setAttribute("data-add", p.v); act.appendChild(b); }
    }
    var more = el("a", "more-link", "Details"); more.href = p.u; act.appendChild(more);
    $("lb-count").textContent = (i + 1) + " / " + n;
    $("lb").hidden = false;
    document.body.style.overflow = "hidden";
    preload = [ALL[(i + 1) % n], ALL[(i - 1 + n) % n]].map(function (q) { var im = new Image(); im.src = q.l; return im; });
  }
  function closeLb() { $("lb").hidden = true; $("lb-img").src = ""; cur = -1; document.body.style.overflow = ""; }
  function step(d) { if (cur >= 0) openLb(cur + d); }
  document.querySelectorAll("[data-lb]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openLb(Number(b.getAttribute("data-lb"))); });
  });
  $("lb-close").addEventListener("click", closeLb);
  $("lb-prev").addEventListener("click", function (e) { e.stopPropagation(); step(-1); });
  $("lb-next").addEventListener("click", function (e) { e.stopPropagation(); step(1); });
  $("lb").addEventListener("click", function (e) { if (e.target === $("lb")) closeLb(); });
  document.addEventListener("keydown", function (e) {
    if ($("lb").hidden) return;
    if (e.key === "Escape") closeLb();
    else if (e.key === "ArrowRight") { e.preventDefault(); step(1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); step(-1); }
  });
  var sx = 0, sy = 0, tracking = false;
  $("lb").addEventListener("touchstart", function (e) {
    tracking = e.touches.length === 1 && !e.target.closest(".lb-act");
    if (tracking) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
  }, { passive: true });
  $("lb").addEventListener("touchmove", function (e) { if (e.touches.length > 1) tracking = false; }, { passive: true });
  $("lb").addEventListener("touchend", function (e) {
    if (!tracking) return; tracking = false;
    if (window.visualViewport && visualViewport.scale > 1.05) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.5) closeLb();
  }, { passive: true });
})();

/* ---- pre-launch countdown (balloon digits). At zero: "Opening the doors…" and reload until the
   products are ACTIVE (the page then renders the real shop and this block isn't on it). ---- */
(function () {
  var cd = document.getElementById("countdown");
  if (!cd || !window.S16_DIGITS) return;
  var D = window.S16_DIGITS, target = Date.parse(cd.getAttribute("data-open"));
  D.forEach(function (u) { var i = new Image(); i.src = u; });             // preload all ten
  var slots = [].slice.call(cd.querySelectorAll("img[data-d]"));
  var shown = [];
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function tick() {
    var ms = Math.max(0, target - Date.now()), s = Math.floor(ms / 1000);
    var str = pad(Math.min(99, Math.floor(s / 86400))) + pad(Math.floor(s / 3600) % 24) + pad(Math.floor(s / 60) % 60) + pad(s % 60);
    slots.forEach(function (img, k) {
      var c = str.charAt(k);
      if (shown[k] === c) return;
      var first = shown[k] === undefined;
      shown[k] = c;
      img.src = D[+c];
      if (!first) { img.classList.remove("pop"); void img.offsetWidth; img.classList.add("pop"); }
    });
    cd.setAttribute("aria-label", "The show is live in " + Math.floor(s / 86400) + " days " + (Math.floor(s / 3600) % 24) + " hours " + (Math.floor(s / 60) % 60) + " minutes");
    if (ms === 0) {
      clearInterval(timer);
      cd.querySelector(".cd__live").hidden = false;
      // stagger the reloads so opening night isn't one thundering herd
      setInterval(function () { location.reload(); }, 12000 + Math.random() * 8000);
    }
  }
  var timer = setInterval(tick, 250);
  tick();
})();
